import React from 'react';
import Popover from '@mui/material/Popover';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Link from '@mui/material/Link';
import { Services } from '../../config/services';

type ServicesPopoverProps = {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
};

const ServicesPopover: React.FC<ServicesPopoverProps> = ({
  anchorEl,
  open,
  onClose,
}) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      PaperProps={{
        sx: {
          mt: 1,
          borderRadius: 2,
          boxShadow: 3,
          minWidth: 520,
          maxWidth: 720,
          p: 2,
        },
        onMouseLeave: onClose,
      }}
    >
      <Box sx={{ display: 'flex', gap: 2 }}>
        <LeftIntroPanel/>
        <ServicesList onItemClick={onClose} />
      </Box>
    </Popover>
  );
};


const LeftIntroPanel: React.FC = () => (
  <Box
    sx={{
      flex: '0 0 220px',
      bgcolor: 'grey.100',
      borderRadius: 2,
      p: 2,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
    }}
  >
    <Box>
      <Typography variant="subtitle2" color="text.secondary">
        Vyber službu
      </Typography>
      <Typography variant="h6" sx={{ mt: 1 }}>
        Prohlížej API dokumentaci
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        Zvol jednu z dostupných služeb napravo a zobraz její OpenAPI
        specifikaci.
      </Typography>
    </Box>
  </Box>
);

type ServicesListProps = {
  onItemClick: () => void;
};

const ServicesList: React.FC<ServicesListProps> = ({
  onItemClick,
}) => (
  <Box sx={{ flex: 1, minWidth: 260 }}>
    {Object.entries(Services).map(([key, item], index, arr) => (
      <Box key={key}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            py: 1,
          }}
        >
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              bgcolor: 'grey.400',
              mr: 1.5,
            }}
          />
          <Box sx={{ flex: 1 }}>
            <Link
              href={`/services/${key}/`}
              underline="none"
              color={'text.primary'}
              sx={{
                fontWeight:  400,
                '&:hover': { textDecoration: 'underline' },
              }}
              onClick={onItemClick}
            >
              {item.name}
            </Link>
            <Typography variant="caption" color="text.secondary" display="block">
              {item.label}
            </Typography>
          </Box>
        </Box>
        {index < arr.length - 1 && <Divider />}
      </Box>
    ))}
  </Box>
);

export default ServicesPopover;
